import React, { useState, useEffect, useMemo } from "react";
import {
  useTable,
  usePagination,
  useGlobalFilter,
  useSortBy,
} from "react-table";
import Swal from "sweetalert2";
import Select from "react-select";
import { SERVER_BASE } from "../config/server";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faPaperPlane,
  faTrash,
  faEllipsisV,
  faEye,
  faCheckCircle,
  faPencil,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import apiClient from "../utils/apiClient";
import "bootstrap/dist/css/bootstrap.min.css";
import ApproverModal from "./ApproverModal";
import { useNavigate } from "react-router-dom";
import moment from "moment";
const GatePassList = ({ permissions }) => {
  const [showForm, setShowForm] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [ledgerOptions, setLedgerOptions] = useState([]);

  const [formData, setFormData] = useState({
    isBilwaVehicle: false,
    freightOn: false, // false for On Sewa, true for On Freight
    copyCollected: false,
    siNumber: "",
    gpNo: "",
    vehicleNumber: "",
    driverName: "",
    mobileNumber: "",
    ledgerName: "",
    remarks: "",
    totalFreight: "",
    advancePaid: "",
    toPay: "",
    transporterName: "",
    transporterGSTIN: "",
    documentGRNo: "",
    documentGRDate: "",
    documentCollected: "",
    itemsChecked: null,
    itemsCount: null,
    qualityInformed: null,
    countInformed: null,
  });
  const [gatePassID, setGatePassID] = useState(null);
  const [profileDetails, setProfileDetails] = useState(null); // State for profile details
  const [gatePasses, setGatePasses] = useState([]);
  const [personOptions, setPersonOptions] = useState([]);
  const code = localStorage.getItem("code");
  const token = localStorage.getItem("token");
  const email = localStorage.getItem("email"); // Retrieve email from localStorage
  const name = localStorage.getItem("name");
  const badgeId = localStorage.getItem("badgeId");
  const [modalShow, setModalShow] = useState(false);
  const [loadingGatePass, setLoadingGatePass] = useState(true);
  const navigate = useNavigate();

  const fetchProfileDetails = async () => {
    try {
      const response = await apiClient.get(`${SERVER_BASE}/getProfile`, {
        params: { email },
      });
      setProfileDetails(response.data?.[0] || null); // Assume the first row contains the profile data
    } catch (err) {
      console.error("Error fetching profile details:", err);
      setProfileDetails(null);
    }
  };
  const fetchGatePass = async () => {
    setLoadingGatePass(true);
    try {
      const response = await apiClient.get(SERVER_BASE + "/getGatePass", {
        params: { code: code },
        headers: {
          Authorization: `Bearer ${token}`, // Add the JWT token in the header
        },
      });
      setLoadingGatePass(false);
      setGatePasses(response.data);
    } catch (error) {
      setLoadingGatePass(false);
      console.error("Error fetching Gate Pass:", error);
    }
  };
  const fetchPersons = async () => {
    try {
      const response = await apiClient.get(`${SERVER_BASE}/getApprovers`, {
        // Assuming there's an endpoint to fetch persons
        headers: {
          Authorization: `Bearer ${token}`, // Add the JWT token in the header
        },
      });
      setPersonOptions(
        response.data.map((person) => ({
          value: person.id,
          label: `${person.firstName} ${person.lastName} - ${person.contactNo}`, // Assuming 'firstName' and 'lastName' are available
          mobileNo: person.contactNo,
          badgeId: person.badgeId,
        }))
      );
    } catch (error) {
      console.error("Error fetching persons for approval:", error);
    }
  };
  const closeModal = () => {
    setModalShow(false); // Close the modal
  };
  useEffect(() => {
    fetchProfileDetails();
    fetchGatePass();
    fetchPersons();
  }, []);

  const handleEdit = (row) => {
    navigate("../addGatePass", { state: { rowData: row } });
  };

  const handleDelete = async (row) => {
    const { id } = row; // Destructure the necessary fields from row.original

    const confirmation = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this gate pass entry? This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });

    if (confirmation.isConfirmed) {
      try {
        // Send the entire row data to the server
        await apiClient.delete(SERVER_BASE + "/deleteGatePass", {
          data: { id, code },
          headers: {
            Authorization: `Bearer ${token}`, // Add the JWT token in the header
          },
        });

        fetchGatePass();

        Swal.fire({
          icon: "success",
          title: "Entry deleted successfully!",
          toast: true,
          position: "top-end",
          timer: 3000,
          showConfirmButton: false,
        });
      } catch (error) {
        console.error("Error deleting Entry:", error);

        Swal.fire({
          icon: "error",
          title: "An error occurred while deleting the Entry.",
          toast: true,
          position: "top-end",
          timer: 3000,
          showConfirmButton: false,
        });
      }
    }
  };

  // Handle Send for Approval (opens modal)
  const handleSendForApproval = (gatepassId) => {
    if (!token) {
      window.location.href = "/";
    } else {
      setGatePassID(gatepassId);
      setModalShow(true); // Show modal
    }
  };

  // Handle Modal Submit (send for approval)
  const handleModalSubmit = async (personId) => {
    const selectedPerson = personOptions.find(
      (person) => String(person.value) === String(personId)
    );
    const mobileNo = selectedPerson?.mobileNo;
    try {
      // API call to send for approval
      await apiClient.post(
        `${SERVER_BASE}/sendForApproval/${gatePassID}`,
        { personId, type: "gatePass" },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const baseLink = `https://rs.iosystem.in/PreviewGatePass?id=${gatePassID}`;
      const fullLink = `${baseLink}&gatepassId=${gatePassID}&personId=${personId}&type=gatePass`;
      const whatsappLink = `https://wa.me/+91${mobileNo}?text=${encodeURIComponent(
        `Please Approve this Gate Pass: ${fullLink}`
      )}`;
      window.open(whatsappLink, "_blank");

      setModalShow(false); // Close modal after successful submission
    } catch (error) {
      console.error("Error sending for approval:", error);
      setModalShow(false); // Close modal on error
    }
  };

  const handleView = (row) => {
    navigate("../../PreviewGatePass", { state: { id: row.id } });
  };
  const columns = useMemo(
    () => [
      {
        Header: "S.No",
        Cell: ({ row }) => row.index + 1,
      },
      {
        Header: "GP Number",
        accessor: "gatePassCode",
      },
      {
        Header: "Date",
        accessor: "gatePassDate",
        Cell: ({ value }) => {
          if (!value) return "";

          // Parse the date, add 5 hours and 30 minutes, and format it
          const date = new Date(value);
          date.setHours(date.getHours() + 5);
          date.setMinutes(date.getMinutes() + 30);

          // Format to DD-MMM-YY
          const formattedDate = date.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "2-digit",
          });

          return formattedDate;
        },
      },
      {
        Header: "Vehicle Number",
        accessor: "vehicleNumber",
      },
      {
        Header: "Driver",
        accessor: "driverName",
      },
      {
        Header: "Mobile Number",
        accessor: "mobileNum",
      },
      {
        Header: "Prepared By",
        accessor: "createdBy",
      },
      {
        Header: "Authorised By",
        accessor: "approvedBy",
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value }) => {
          if (value === "Pending") {
            return <span className="badge bg-warning text-dark">Pending</span>;
          } else if (value === "Approved") {
            return (
              <span className="badge bg-success text-white">Approved</span>
            );
          }
        },
      },
      {
        Header: "Preview",
        accessor: "Preview",
        Cell: ({ row }) => {
            return  (
              permissions?.read && (
                  
                <button
                  className="btn btn-sm btn-outline-success me-1"
                  onClick={() => handleView(row.original)}
                >
                View
                </button>
          
            )
            )
        },
      },
      {
        Header: "#",
        accessor: "actions",
        Cell: ({ row }) => {
          return (
            (permissions?.read || permissions?.edit || permissions?.delete) && (
              <div className="dropdown">
                   {/* {permissions?.read && (
                  
                      <button
                        className="btn btn-sm btn-outline-success me-1"
                        onClick={() => handleView(row.original)}
                      >
                      View
                      </button>
                
                  )} */}
                <button
                  className="btn btn-light"
                  type="button"
                  id={`dropdownMenuButton-${row.index}`}
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <FontAwesomeIcon icon={faEllipsisV} />
                </button>
                <ul
                  className="dropdown-menu dropdown-menu-end"
                  aria-labelledby={`dropdownMenuButton-${row.index}`}
                >
                  {/* Conditionally render actions based on status */}
                  {row.original.status !== "Approved" && (
                    <>
                      {permissions?.edit && (
                        <li>
                          <button
                            className="dropdown-item"
                            onClick={() => handleEdit(row.original)}
                          >
                            <FontAwesomeIcon icon={faEdit} /> Edit
                          </button>
                        </li>
                      )}
                      {permissions?.delete && (
                        <li>
                          <button
                            className="dropdown-item"
                            onClick={() => handleDelete(row.original)}
                          >
                            <FontAwesomeIcon icon={faTrash} /> Delete
                          </button>
                        </li>
                      )}
                      {permissions?.read && (
                        <li>
                          <button
                            className="dropdown-item"
                            onClick={() =>
                              handleSendForApproval(row.original.id)
                            }
                          >
                            <FontAwesomeIcon icon={faPaperPlane} /> Send for
                            Approval
                          </button>
                        </li>
                      )}
                    </>
                  )}
                  {/* Always show the View option */}
               
                  <li>
                    <hr />
                  </li>
                  <li className="dropdown-item text-muted">
                    <FontAwesomeIcon icon={faPlus} />{" "}
                    {row.original.createdBy
                      ? `${row.original.createdBy} (${
                          row.original.createdAt
                            ? moment(row.original.createdAt).format(
                                "DD-MMM-YY hh:mm A"
                              )
                            : ""
                        }) `
                      : "-"}
                  </li>
                  {row.original.updatedBy ? (
                    <li className="dropdown-item text-muted">
                      <FontAwesomeIcon icon={faPencil} />{" "}
                      {row.original.updatedBy
                        ? `${row.original.updatedBy} (${
                            row.original.updatedAt
                              ? moment(row.original.updatedAt).format(
                                  "DD-MMM-YY hh:mm A"
                                )
                              : ""
                          })`
                        : ""}
                    </li>
                  ) : null}
                  {row.original.approvedBy ? (
                    <li className="dropdown-item text-muted">
                      <FontAwesomeIcon icon={faCheckCircle
                      } />{" "}
                      {`${row.original.approvedBy}${
                        row.original.approvedAt
                          ? ` (${moment(row.original.approvedAt).format(
                              "DD-MMM-YY hh:mm A"
                            )})`
                          : ""
                      }`}
                    </li>
                  ) : null}
                </ul>
              </div>
            )
          );
        },
      },
    ],
    [gatePasses,permissions]
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    setGlobalFilter,
    canPreviousPage,
    canNextPage,
    pageOptions,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize, globalFilter },
  } = useTable(
    {
      columns,
      data: gatePasses,
      initialState: { pageIndex: 0, pageSize: 20 }, // min-20 page size
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );
  if (loadingGatePass) {
    return (
      <div
        className="d-flex flex-column justify-content-center align-items-center"
        style={{ height: "60vh" }}
      >
        <div
          className="spinner-border text-success"
          role="status"
          style={{ width: "3rem", height: "3rem" }}
        >
          <span className="visually-hidden">Loading...</span>
        </div>
        <div className="mt-3 fs-5">Please wait...</div>
      </div>
    );
  }
  return (
   
      <div className="formcontainer mt-5">
        <h3 className="mb-2">Gate Pass</h3>
        <div className="d-flex justify-content-between gap-2 mb-2">
          {permissions?.write && (
            <>
              <button
                className="btn btn-outline-success"
                onClick={() => {
                  navigate("../addGatePass");
                }}
              >
                Add Gate Pass
              </button>
            </>
          )}
          {permissions?.read && (
            <>
              <input
                type="text"
                className="form-control"
                placeholder="Search gate pass"
                value={globalFilter || ""}
                onChange={(e) => setGlobalFilter(e.target.value)}
                style={{ width: "75%" }}
              />

              <label className="">
                <select
                  value={pageSize}
                  onChange={(e) => setPageSize(Number(e.target.value))}
                  className="form-select"
                >
                  {[25, 50, 100, 200].map((size) => (
                    <option key={size} value={size}>
                      Show {size}
                    </option>
                  ))}
                </select>
              </label>
            </>
          )}
        </div>
        {permissions?.read && (
          <>
            <table
              {...getTableProps()}
              className="table table-striped"
              style={{ fontSize: "14px" }}
            >
              <thead>
                {headerGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                      <th
                        {...column.getHeaderProps(
                          column.getSortByToggleProps()
                        )}
                      >
                        {column.render("Header")}
                        <span>
                          {column.isSorted
                            ? column.isSortedDesc
                              ? " 🔽"
                              : " 🔼"
                            : ""}
                        </span>
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {page.map((row) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()}>
                      {row.cells.map((cell) => (
                        <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                      ))}
                    </tr>
                  );
                })}
              </tbody>
            </table>

            <div className="d-flex align-items-center mb-3">
              {/* Previous – left corner */}
              <button
                onClick={() => previousPage()}
                disabled={!canPreviousPage}
                className="btn btn-secondary me-auto"
                style={{ minWidth: 110 }} // keeps width consistent
              >
                Previous
              </button>

              {/* Center block for page index & size selector */}
              <div className="text-center flex-grow-1 d-flex flex-column align-items-center">
                {/* Row 1: Page index and size selector in one line */}
                <div className="d-flex align-items-center gap-3">
                  <div className="fw-semibold">
                    Page {pageIndex + 1} of {pageOptions.length}
                  </div>
                </div>
              </div>

              {/* Next – right corner */}
              <button
                onClick={() => nextPage()}
                disabled={!canNextPage}
                className="btn btn-secondary ms-auto"
                style={{ minWidth: 110 }}
              >
                Next
              </button>
            </div>
          </>
        )}
          <ApproverModal
        show={modalShow}
        title="Send for Approval"
        options={personOptions}
        close={closeModal} // Pass close function
        onSubmit={handleModalSubmit}
      />
      </div>

    
   
  );
};

export default GatePassList;
